import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  WithStyles,
  withStyles,
  Divider,
  MenuItem,
  ListItemText,
  Grid,
  Typography,
  Chip,
  Theme,
  Checkbox,
  FormControlLabel,
  IconButton,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
} from "@material-ui/core";
import * as React from "react";
import { Formik } from "formik";
import * as Yup from "yup";

import {
  RESPONSE_TYPES,
  OPTIONS,
  PRIMITIVE_TYPES,
  convertTextToTitleCase,
  convertToBoolean,
} from "../constants/constants";
import ColorPickerComponent from "../components/ColorPickerComponent";
import RetrieveOptionsDialog from "./RetrieveOptionsDialog";
import EditIcon from "@material-ui/icons/Edit";
import OpenIcon from "@material-ui/icons/Launch";
import SelectResponseTypeDialog from "./SelectResponseTypeDialog";
export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_ACTION: "DIALOG_ACTION",
};

const styles = (theme: Theme) =>
  createStyles({
    chip: {
      margin: theme.spacing(0.5),
    },
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      width: "100%",
    },
    button: {
      margin: theme.spacing(1),
      height: 40,
    },
  });
const validationSchema = Yup.object().shape({
  question: Yup.string().required("Question required"),
  legend: Yup.string().notRequired(),
  responseType: Yup.string().required("Please select response type"),
});
interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  editData: any;
  handleClose: any;
  uniqueMachineNumbers: any;
  uniqueNames: any;
  uniqueTypes: any;
  equipments: any;
  companyData: any;
  legends?: any;
  handleOnSubmit: any;
}

class AddQuestionDialog extends React.Component<Props> {
  state = {
    hasError: false,
    type: "",
    indexSelected: -1,
    questionOptions: Array<any>(),
    questionOptionsValue: { value: "", label: "" },
    captureRetrieveOptions: false,
    openSelectResponseType: false,
    results: {
      retriveOptionFrom: "",
      retrieveElement: "",
      secondaryRetriveElement: "",
      retrieveItems: Array<any>(),
    },
  };

  componentDidMount = () => {
    this.setState({
      questionOptions:
        this.props.editData && this.props.editData.questionOptions
          ? this.props.editData.questionOptions
          : Array<any>(),
      selectedOption:
        this.props.editData &&
        this.props.editData.responseType &&
        this.props.editData.responseType.title
          ? this.props.editData.responseType
          : { title: "", label: "" },
    });
  };

  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (
      prevProps.editData.questionOptions !== this.props.editData.questionOptions
    ) {
      this.setState({
        questionOptions:
          this.props.editData && this.props.editData.questionOptions
            ? this.props.editData.questionOptions
            : Array<any>(),
        results:
          this.props.editData && this.props.editData.retrieveDetails
            ? this.props.editData.retrieveDetails
            : {},
        selectedOption:
          this.props.editData && this.props.editData.responseType
            ? this.props.editData.responseType
            : { title: "", label: "" },
      });
    }
  };

  handleRemoveQuestionOptionsTypeChip = (item: any, index: any) => {
    let items = [...this.state.questionOptions];
    items.splice(index, 1);
    this.setState({
      questionOptions: items,
    });
  };
  onQuestionOptionsAddClicked = () => {
    if (this.state.questionOptionsValue) {
      let currentOptions = this.state.questionOptions;
      currentOptions.push(this.state.questionOptionsValue);
      this.setState({
        questionOptions: currentOptions,
        questionOptionsValue: { value: "", label: "" },
      });
    }
  };

  getResponse = (typeKey: any) => {
    let response = {};
    RESPONSE_TYPES.map((responseType: any) => {
      if (responseType.title === typeKey) {
        response = responseType;
      }
      return null;
    });
    return response;
  };
  getPrimitiveResponse = (typeKey: any) => {
    let response = {};
    PRIMITIVE_TYPES.map((responseType: any) => {
      if (responseType.value === typeKey) {
        response = responseType;
      }
      return null;
    });
    return response;
  };
  renderForm = () => {};
  renderSelectReponseTypeDialog = (setFieldValue: any, values: any) => {
    return (
      <SelectResponseTypeDialog
        title={"Select Response Type"}
        selectedOption={values.responseType}
        handleClose={() => {
          this.setState({
            openSelectResponseType: false,
          });
        }}
        handleOnSubmit={(option: any) => {
          setFieldValue("responseType", option);
          if (option.title === "Options") {
            this.setState({
              captureRetrieveOptions: true,
              openSelectResponseType: false,
            });
          } else {
            this.setState({
              openSelectResponseType: false,
            });
          }
        }}
        open={this.state.openSelectResponseType}
      />
    );
  };
  rendeCaptureRetrieveDialog = () => {
    return (
      <RetrieveOptionsDialog
        dialogTitle={"Retrive Options"}
        onClose={() => {
          this.setState({
            captureRetrieveOptions: false,
          });
        }}
        retrieveDetails={
          this.props.editData && this.props.editData.question
            ? this.state.results
            : {}
        }
        uniqueMachineNumbers={this.props.uniqueMachineNumbers}
        uniqueNames={this.props.uniqueNames}
        uniqueTypes={this.props.uniqueTypes}
        equipments={this.props.equipments}
        open={this.state.captureRetrieveOptions}
        companyData={this.props.companyData}
        onSubmit={(results: any) => {
          this.setState({
            captureRetrieveOptions: false,
            results: results,
          });
        }}
      />
    );
  };
  render() {
    const { title, open, editData, handleClose, classes, handleOnSubmit } =
      this.props;
    return (
      <React.Fragment>
        <Dialog
          open={open}
          keepMounted={true}
          onClose={() => handleClose()}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
        >
          <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
          <Divider />
          <DialogContent>
            <Formik
              initialValues={
                editData && editData.question
                  ? editData
                  : {
                      question: "",
                      importQuestion: "",
                      legend: "",
                      analyticsKey: "",
                      responseType: "",
                      option: "",
                      questionOptions: new Array<any>(),
                      hasOptions: false,
                      includeTimeCapture: false,
                      selectMultiple: false,
                      retrieveDetails: {
                        retriveOptionFrom: "",
                        retrieveElement: "",
                        retrieveItems: new Array<any>(),
                        secondaryRetriveElement: "",
                      },
                      primitiveType: {
                        label: "",
                        value: "",
                        type: "",
                        length: -1,
                      },
                    }
              }
              enableReinitialize={true}
              validationSchema={validationSchema}
              validateOnMount={true}
              onSubmit={() => {}}
            >
              {({
                values,
                handleChange,
                isValid,
                handleReset,
                setFieldValue,
              }) => {
                return (
                  <div>
                    {this.renderSelectReponseTypeDialog(setFieldValue, values)}
                    <TextField
                      style={{
                        width: "80%",
                        margin: 10,
                        height: 50,
                      }}
                      id={"question"}
                      value={values.question}
                      name={"question"}
                      onChange={handleChange}
                      label={"Question"}
                      fullWidth={true}
                    />
                    <TextField
                      style={{
                        width: "80%",
                        margin: 10,
                        height: 50,
                      }}
                      id={"importQuestion"}
                      value={values.importQuestion}
                      name={"importQuestion"}
                      onChange={handleChange}
                      label={"Import Question"}
                      fullWidth={true}
                    />
                    <Typography
                      style={{ color: "red", fontSize: 12, marginLeft: 10 }}
                    >
                      {
                        "Please add the question corresponding to column for import."
                      }
                    </Typography>
                    <TextField
                      style={{
                        width: "80%",
                        margin: 10,
                        height: 50,
                      }}
                      id={"analyticsKey"}
                      value={values.analyticsKey}
                      name={"analyticsKey"}
                      onChange={handleChange}
                      label={"Analytics keyword"}
                      fullWidth={true}
                    />
                    <TextField
                      style={{
                        width: "80%",
                        margin: 10,
                        height: 50,
                      }}
                      select
                      id={"option"}
                      label={"Select Option"}
                      margin="dense"
                      value={values.option ? values.option : ""}
                      onChange={(event) => {
                        setFieldValue("option", event.target.value);
                      }}
                      fullWidth
                    >
                      {OPTIONS.map((option: any, index: any) => (
                        <MenuItem key={index.toString()} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <FormControl
                        style={{
                          width: "80%",
                          margin: 10,
                          height: 50,
                        }}
                        fullWidth={true}
                      >
                        <InputLabel
                          shrink={true}
                          htmlFor="standard-adornment-password"
                        >
                          {"Select response type"}
                        </InputLabel>
                        <Input
                          id="standard-adornment-password"
                          contentEditable={false}
                          value={
                            values.responseType.title
                              ? values.responseType.title
                              : ""
                          }
                          onChange={(event) => {
                            setFieldValue(
                              "responseType",
                              this.getResponse(event.target.value)
                            );
                            if (event.target.value === "Options") {
                              this.setState({
                                captureRetrieveOptions: true,
                              });
                            }
                          }}
                          inputComponent={(props) => {
                            return (
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  flexDirection: "row",
                                  height: 24,
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Typography>
                                  {props.value.split("_").length > 0
                                    ? convertTextToTitleCase(
                                        props.value.split("_")[0]
                                      )
                                    : convertTextToTitleCase(props.value)}
                                </Typography>
                                <Typography>
                                  {values.responseType.label}
                                </Typography>
                              </div>
                            );
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => {
                                  this.setState({
                                    openSelectResponseType: true,
                                  });
                                }}
                              >
                                <OpenIcon fontSize={"small"} />
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>

                      {values.responseType.title === "Options" &&
                        this.props.editData &&
                        this.props.editData.question && (
                          <Button
                            variant="contained"
                            className={classes.button}
                            style={{ backgroundColor: "orange" }}
                            startIcon={<EditIcon />}
                            onClick={() =>
                              this.setState({
                                captureRetrieveOptions: true,
                              })
                            }
                          >
                            Edit
                          </Button>
                        )}
                    </div>
                    <div>
                      <FormControlLabel
                        label="Include Time Capture"
                        control={
                          <Checkbox
                            id={"includeTimeCapture"}
                            name={"includeTimeCapture"}
                            checked={convertToBoolean(
                              values.includeTimeCapture
                            )}
                            onChange={(event: any) => {
                              setFieldValue(
                                "includeTimeCapture",
                                event.target.checked
                              );
                            }}
                          />
                        }
                      />
                    </div>
                    {!values.responseType ||
                    values.responseType.title === "COMMENT" ||
                    values.responseType.title === "NUMERIC" ? (
                      <div />
                    ) : (
                      <div style={{ marginTop: 10, marginBottom: 10 }}>
                        {values.responseType.response &&
                          values.responseType.response.positiveColor && (
                            <ColorPickerComponent
                              title={"Postive Color"}
                              handleInputColorSelected={(inputColor: any) => {
                                let responseType = values.responseType;
                                if (responseType.response) {
                                  responseType.response.positiveColor =
                                    inputColor;
                                }
                                setFieldValue("responseType", responseType);
                              }}
                              selectedColor={
                                values.responseType &&
                                values.responseType.response &&
                                values.responseType.response.positiveColor
                                  ? values.responseType.response.positiveColor
                                  : ""
                              }
                            />
                          )}
                        {values.responseType.response &&
                          values.responseType.response.negativeColor && (
                            <ColorPickerComponent
                              title={"Negative/Neutral Color"}
                              handleInputColorSelected={(inputColor: any) => {
                                let responseType = values.responseType;
                                if (responseType.response) {
                                  responseType.response.negativeColor =
                                    inputColor;
                                }
                                setFieldValue("responseType", responseType);
                              }}
                              selectedColor={
                                values.responseType &&
                                values.responseType.response &&
                                values.responseType.response.negativeColor
                                  ? values.responseType.response.negativeColor
                                  : ""
                              }
                            />
                          )}
                      </div>
                    )}
                    {values.responseType &&
                      (values.responseType.title === "COMMENT" ||
                        values.responseType.title === "NUMERIC") && (
                        <div style={{ marginLeft: 8 }}>
                          <FormControlLabel
                            label="Has Options"
                            control={
                              <Checkbox
                                id={"hasOptions"}
                                name={"hasOptions"}
                                checked={values.hasOptions ? true : false}
                                onChange={(event: any) => {
                                  setFieldValue("primitiveType", {
                                    label: "",
                                    value: "",
                                    type: "",
                                    length: -1,
                                  });
                                  setFieldValue(
                                    "hasOptions",
                                    event.target.checked
                                  );
                                }}
                                value="Has Options"
                              />
                            }
                          />
                          <FormControlLabel
                            label="Select Multiple"
                            control={
                              <Checkbox
                                id={"selectMultiple"}
                                name={"selectMultiple"}
                                checked={
                                  values.selectMultiple
                                    ? values.selectMultiple
                                    : false
                                }
                                onChange={(event: any) => {
                                  setFieldValue(
                                    "selectMultiple",
                                    event.target.checked
                                  );
                                }}
                                value="Select Multiple"
                              />
                            }
                          />
                          {values.hasOptions && (
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  margin: 10,
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <TextField
                                  fullWidth
                                  id="standard-basic"
                                  label="Options"
                                  value={this.state.questionOptionsValue.label}
                                  placeholder="Add Options"
                                  onChange={(event: any) => {
                                    let currentOptionsValue =
                                      this.state.questionOptionsValue;
                                    currentOptionsValue.value =
                                      event.target.value.includes("-")
                                        ? event.target.value.toUpperCase()
                                        : event.target.value
                                            .replace(" ", "-")
                                            .toUpperCase();
                                    currentOptionsValue.label =
                                      event.target.value;
                                    this.setState({
                                      optionsValue: currentOptionsValue,
                                    });
                                  }}
                                />
                                <Button
                                  variant="outlined"
                                  disabled={
                                    this.state.questionOptionsValue &&
                                    this.state.questionOptionsValue.label &&
                                    this.state.questionOptionsValue.value
                                      ? false
                                      : true
                                  }
                                  onClick={() =>
                                    this.onQuestionOptionsAddClicked()
                                  }
                                  style={{ marginLeft: 20 }}
                                >
                                  ADD
                                </Button>
                              </div>
                              {this.state.questionOptions.map(
                                (item: any, index: number) => {
                                  return (
                                    <Chip
                                      key={index.toString()}
                                      className={classes.chip}
                                      label={item.label}
                                      onDelete={() =>
                                        this.handleRemoveQuestionOptionsTypeChip(
                                          item,
                                          index
                                        )
                                      }
                                    />
                                  );
                                }
                              )}
                            </div>
                          )}
                          {!values.hasOptions && (
                            <TextField
                              style={{
                                width: "80%",
                                margin: 10,
                                height: 50,
                              }}
                              select
                              id={"primitiveType"}
                              label={"Primitive Type"}
                              value={
                                values.primitiveType &&
                                values.primitiveType.value
                                  ? values.primitiveType.value
                                  : ""
                              }
                              onChange={(event) => {
                                setFieldValue(
                                  "primitiveType",
                                  this.getPrimitiveResponse(event.target.value)
                                );
                              }}
                              fullWidth={true}
                            >
                              {PRIMITIVE_TYPES.map(
                                (option: any, index: any) => (
                                  <MenuItem
                                    key={index.toString()}
                                    value={option.value}
                                  >
                                    <Grid container spacing={3}>
                                      <Grid item xs={3}>
                                        <ListItemText>
                                          {option.label}
                                        </ListItemText>
                                      </Grid>
                                    </Grid>
                                  </MenuItem>
                                )
                              )}
                            </TextField>
                          )}
                        </div>
                      )}
                    <div style={{ marginTop: 10, marginBottom: 10 }}></div>
                    <DialogActions>
                      <Button
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        {"CANCEL"}
                      </Button>
                      <Button
                        // disabled={!isValid}
                        onClick={async () => {
                          values.questionOptions = this.state.questionOptions;
                          values.retrieveDetails = this.state.results;
                          await handleOnSubmit(values);
                          handleReset();
                        }}
                      >
                        {"SAVE"}
                      </Button>
                    </DialogActions>
                  </div>
                );
              }}
            </Formik>
          </DialogContent>
        </Dialog>
        {this.rendeCaptureRetrieveDialog()}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AddQuestionDialog);
